import PartyPivotReport from "@/components/PartyPivotReport";

const PARTY_TYPES = [
  { value: "all", label: "All Parties" },
  { value: "creditor", label: "Sundry Creditors" },
  { value: "debtor", label: "Sundry Debtors" },
  { value: "branch", label: "Branches" },
  { value: "related", label: "Related / Capital" },
  { value: "other", label: "Other" },
];

export default function PartyExpense({ companyContext }) {
  return (
    <PartyPivotReport
      companyContext={companyContext}
      endpoint="party-expense"
      title="Party-wise Expense Report"
      subtitle="Monthly breakdown by party across Payment / Purchase / Journal vouchers. Click any row to see ledger breakdown."
      partyTypeOptions={PARTY_TYPES}
      totalColor="text-rose-700"
      testIdPrefix="party-expense"
    />
  );
}
